module.exports = __webpack_public_path__ + "img/142-basque country.8530cf6a.svg";